import { jsx } from 'react/jsx-runtime';
import Script from 'next/script';

const createFaqPageJsonLd = faqList => ({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map(({ title: name, content: text, }) => ({
        '@type': 'Question',
        name,
        acceptedAnswer: {
            '@type': 'Answer',
            text,
        },
    })),
});

const FaqPageStructuredData = ({ list, suppressHydrationWarning, }) => (jsx(Script, { strategy: "beforeInteractive", suppressHydrationWarning: suppressHydrationWarning, type: "application/ld+json", children: JSON.stringify(createFaqPageJsonLd(list)) }));

export { FaqPageStructuredData as F };
//# sourceMappingURL=component-f-K6lwMA.js.map
